export const devMode = window.location.href.includes('localhost:3000');

const urlPrefix = "https://ix-test-test.integration-x.internal";
export const urlPath = devMode? urlPrefix + "/xServer": "..";
export const htmlUrlPath = devMode? urlPrefix: "";
export const imageUrlPath = devMode? urlPrefix: "";



// WEBPACK FOOTER //
// ./src/components/Settings.js